// extracted by mini-css-extract-plugin
module.exports = {"root":"ComposeQuery-module__root__2hmGz","btn-compose":"ComposeQuery-module__btn-compose__tYAso"};